import { render, staticRenderFns } from "./SimcardStatusChart.vue?vue&type=template&id=567ede42&"
import script from "./SimcardStatusChart.vue?vue&type=script&lang=js&"
export * from "./SimcardStatusChart.vue?vue&type=script&lang=js&"
import style0 from "./SimcardStatusChart.vue?vue&type=style&index=0&id=567ede42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports